/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/

import type {
  MasterDataListRequest,
  MasterDataListResponse,
  MasterDataShopResponse
} from '../../models';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Returns shop data for multiple shops at the same time
 */
export const getShops = (
    masterDataListRequest: MasterDataListRequest,
 options?: SecondParameter<typeof customInstance<MasterDataListResponse>>,) => {
      return customInstance<MasterDataListResponse>(
      {url: `/api/v1/masterdata/shop`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: masterDataListRequest
    },
      options);
    }
  /**
 * Returns a shop based on a given id or short id
 */
export const getShop = (
    idOrShortId: string,
 options?: SecondParameter<typeof customInstance<MasterDataShopResponse>>,) => {
      return customInstance<MasterDataShopResponse>(
      {url: `/api/v1/masterdata/shop/${idOrShortId}`, method: 'GET'
    },
      options);
    }
  export type GetShopsResult = NonNullable<Awaited<ReturnType<typeof getShops>>>
export type GetShopResult = NonNullable<Awaited<ReturnType<typeof getShop>>>
